export type ToastType = 'success' | 'error' | 'info';

export interface ToastEvent {
  message: string;
  type: ToastType;
}

const TOAST_EVENT = 'extramile:toast';

const toastHistory = new Map<string, number>();
const RECENT_DEDUP_WINDOW_MS = 3000;

/** Fire a global toast from anywhere (including Axios interceptors) with duplicate throttling */
export function showGlobalToast(message: string, type: ToastType = 'error'): void {
  const now = Date.now();
  const key = `${type}:${message}`;
  const lastFired = toastHistory.get(key) ?? 0;

  // Suppress duplicate toasts fired in rapid succession
  if (now - lastFired < RECENT_DEDUP_WINDOW_MS) {
    return;
  }

  // Throttle generic error toasts to at most once per 5 seconds
  if (type === 'error' && /something went wrong/i.test(message)) {
    const genericLastFired = toastHistory.get('error:generic') ?? 0;
    if (now - genericLastFired < 5000) {
      return;
    }
    toastHistory.set('error:generic', now);
  }

  toastHistory.set(key, now);
  window.dispatchEvent(new CustomEvent<ToastEvent>(TOAST_EVENT, { detail: { message, type } }));
}

export { TOAST_EVENT };

